export default class SidebarShowMore {
  constructor(element) {
    this.component = element
    this.list = element.querySelector('.js-read-more-list')
    this.items = [...element.querySelectorAll('.sidebar__nav-item')]
    this.trigger = element.querySelector('.js-read-more-trigger')
    this.triggeText = element.querySelector('.js-read-more-trigger span')
    this.text = ['Alle anzeigen', 'Zeige weniger']
    this.blockHeight = 0

    this.init()
  }


  init() {
    this.addListener()
    this.getListHeight()

    window.addEventListener('resize', () => {
      this.getListHeight()

      if (this.component.classList.contains('js-active')) {
        this.list.style.height = 'auto'
      }
    })
  }

  addListener() {
    this.trigger.addEventListener('click', (e) => {
      e.preventDefault()

      this.component.classList.toggle('js-active')

      if (this.component.classList.contains('js-active')) {
        this.triggeText.textContent = this.text[1]
        this.list.style.height = `${this.blockHeight}px`
      } else {
        this.triggeText.textContent = this.text[0]
        this.list.style.height = 0
      }
    })
  }

  getListHeight() {
    let childrenElems = this.list.children;

    [...childrenElems].map(el => {
      this.blockHeight = el.offsetHeight * childrenElems.length
    })
  }
}